// extracted by mini-css-extract-plugin
module.exports = {"root":"FormRegistry_root___8aqb","full":"FormRegistry_full__L8f8e","half":"FormRegistry_half__QEarD"};